//
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from 'app/components/atoms/Icon/Icon';
import PopupMenu from 'app/components/molecules/PopupMenu/PopupMenu';

const ResponsiveActionsStyled = styled.div`
    & i {
        margin-left: 0.6rem;
    }
    & .dropdownActions {
        display: none;
    }
    @media (max-width: ${({ theme }) => theme.media.md}) {
        & > i,
        & > a {
            display: none;
        }
        & .dropdownActions {
            display: inherit;
        }
        & .dropdownActions > div {
            text-align: right;
        }
        & .dropdownActions > div > a {
            width: 34px;
            display: inline-flex;
        }
    }
`;

const ResponsiveActions = props => {
    const { actions, className } = props;
    return (
        <ResponsiveActionsStyled className={className}>
            {actions}
            <PopupMenu content={actions} className="dropdownActions">
                <Icon name="dots-vertical" />
            </PopupMenu>
        </ResponsiveActionsStyled>
    );
};

ResponsiveActions.propTypes = {
    actions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default ResponsiveActions;
